import alt from 'alt'
import { createStore, datasource, bind } from 'alt-utils/lib/decorators'
import { ShopDetailsActions } from 'actions'

@createStore(alt)
export default class ShopDetailsStore {
  constructor() {
    this.state = {
      fetchingDetails: null,
      shopDetails: null,
      noShopDetails: false
    }

    this.bindActions(ShopDetailsActions)
  }

  static displayName = 'ShopDetailsStore'

  setFetching(fetching) {
    this.setState({ fetchingDetails: fetching })
  }

  setDetails(details) {
    this.setState({ shopDetails: details, fetchingDetails: false })
  }

  setErrored(errored) {
    this.setState({ noShopDetails: errored, fetchingDetails: false })
  }
}



// WEBPACK FOOTER //
// ./app/stores/ShopDetailsStore.js